import { useAtom } from "jotai";
import { FC, useMemo } from "react";
import style from "./style.module.css";
import { BatchPlan, PLAN_PURCHASED_STATE, POP_UP_ACTION } from "@components/Sales/batch.type";
import { planTableSelectedPlanAtom } from "@utils/store/store";
import { argbToRgba, cn, getCDNAssetUrl, showPlanBadge } from "@utils/utilities";
import { CHECK_YELLOW, GRAY_TICK_DARK } from "@assets/images/location/ASSETS_IMAGES";

interface props {
  plan: BatchPlan;
  index: number;
  updateRef: (args: HTMLDivElement) => void;
  handleView: (index: number) => void;
  lastPurchasedIndex: number;
  triggerEvent: (actionType: POP_UP_ACTION, plan?: BatchPlan) => void;
}

const PlanCard: FC<props> = ({
  plan,
  index,
  updateRef,
  handleView,
  lastPurchasedIndex,
  triggerEvent,
}) => {
  const [selectedPlan, setPlanTableSelection] = useAtom(
    planTableSelectedPlanAtom,
  );

  const darkMode = useMemo(() => plan?.planImages?.darkMode, [plan]);

  const showPlanPurchaseState = () => {
    switch (plan?.planPurchaseState) {
      case PLAN_PURCHASED_STATE.INCLUDED:
        return "Included";
      case PLAN_PURCHASED_STATE.PURCHASED:
        return lastPurchasedIndex == index ? "Current Plan" : "Purchased";
      default:
        return "";
    }
  };

  const planBadgeUrl = useMemo(() => {
    return showPlanBadge(plan);
  }, [plan]);

  const handlePlanClick = (plan: BatchPlan) => {
    setPlanTableSelection(plan);
    handleView(index);
    triggerEvent(POP_UP_ACTION.PLAN_SELECTED, plan);
  };

  return (
    <div
      ref={(v) => v && updateRef(v)}
      style={{ background: argbToRgba(darkMode?.bgColorHex) }}
      className={cn(style.wrapper, {
        [style.active]: selectedPlan?._id === plan?._id,
        [style.purchased]:
          selectedPlan?._id === plan?._id &&
          [
            PLAN_PURCHASED_STATE.PURCHASED,
            PLAN_PURCHASED_STATE.INCLUDED,
          ].includes(plan?.planPurchaseState),
      })}
      onClick={() => handlePlanClick(plan)}
    >
      <span style={{ color: darkMode?.textColorHex }} className={style.title}>
        <span>{plan?.title}</span>
        <span>{showPlanPurchaseState()}</span>
      </span>

      {darkMode?.webImageUrl && (
        <img className={style.wave} src={darkMode?.webImageUrl} alt="wave" />
      )}
      <div className={style.checkbox}>
        <div
          className={cn([style.checkbox_outline], {
            [style.active]: selectedPlan?._id === plan?._id,
            [style.purchased]:
              selectedPlan?._id === plan?._id &&
              [
                PLAN_PURCHASED_STATE.PURCHASED,
                PLAN_PURCHASED_STATE.INCLUDED,
              ].includes(plan?.planPurchaseState),
          })}
        >
          {selectedPlan?._id === plan?._id && selectedPlan?.isPlanPurchased ? (
            <img src={getCDNAssetUrl(GRAY_TICK_DARK)} />
          ) : selectedPlan?._id === plan?._id ? (
            <img src={getCDNAssetUrl(CHECK_YELLOW)} />
          ) : (
            <></>
          )}
        </div>
      </div>

      {planBadgeUrl && (
        <span className={style.badge}>
          <img src={planBadgeUrl} />
        </span>
      )}
    </div>
  );
};
export default PlanCard;
